// Print layout templates for export (A4 / A3 / A2, landscape & portrait).
// Extracted from rawConfig.ts as part of Phase 2.3 (ANALYSIS.md §5.11).
import {IExportLayouts} from '../../core/interfaces/reducers/IExportMap'

export const layouts: IExportLayouts = {
  A4: {
    landscape: {
      mapProps: {
        resizibleLeft: 50,
        resizibleTop: 50,
        resizibleHeight: 1000,
        resizibleWidth: 1000
      },
      elements: {
        legend: {
          resizibleHeight: 1000,
          resizibleWidth: 516,
          resizibleLeft: 1050,
          resizibleTop: 50,
          type: 'legend'
        },
        scale: {
          resizibleHeight: 64,
          resizibleWidth: 311,
          resizibleLeft: 405,
          resizibleTop: 1044,
          type: 'scale'
        }
      },
      margins: [36, 36, 36, 36],
      zoomFactor: 0.9
    },
    portrait: {
      mapProps: {
        resizibleLeft: 50,
        resizibleTop: 50,
        resizibleHeight: 1000,
        resizibleWidth: 1000
      },
      elements: {
        legend: {
          resizibleHeight: 469,
          resizibleWidth: 990,
          resizibleLeft: 52,
          resizibleTop: 1110,
          type: 'legend'
        },
        scale: {
          resizibleHeight: 64,
          resizibleWidth: 311,
          resizibleLeft: 405,
          resizibleTop: 1044,
          type: 'scale'
        }
      },
      margins: [36, 36, 36, 36],
      zoomFactor: 0.9
    }
  },
  A3: {
    landscape: {
      mapProps: {
        resizibleLeft: 50,
        resizibleTop: 50,
        resizibleHeight: 1400,
        resizibleWidth: 1400
      },
      elements: {
        legend: {
          resizibleHeight: 1516,
          resizibleWidth: 688,
          resizibleLeft: 1600,
          resizibleTop: 34,
          type: 'legend'
        },
        scale: {
          resizibleHeight: 64,
          resizibleWidth: 311,
          resizibleLeft: 631,
          resizibleTop: 1546,
          type: 'scale'
        }
      },
      margins: [36, 36, 36, 36],
      zoomFactor: 0.6
    },
    portrait: {
      mapProps: {
        resizibleLeft: 50,
        resizibleTop: 50,
        resizibleHeight: 1400,
        resizibleWidth: 1400
      },
      elements: {
        legend: {
          resizibleHeight: 796,
          resizibleWidth: 1484,
          resizibleLeft: 50,
          resizibleTop: 1484,
          type: 'legend'
        },
        scale: {
          resizibleHeight: 64,
          resizibleWidth: 311,
          resizibleLeft: 629,
          resizibleTop: 1430,
          type: 'scale'
        }
      },
      margins: [36, 36, 36, 36],
      zoomFactor: 0.6
    }
  },
  A2: {
    landscape: {
      mapProps: {
        resizibleLeft: 50,
        resizibleTop: 50,
        resizibleHeight: 1400,
        resizibleWidth: 1400
      },
      elements: {
        legend: {
          resizibleHeight: 1516,
          resizibleWidth: 688,
          resizibleLeft: 1600,
          resizibleTop: 34,
          type: 'legend'
        },
        scale: {
          resizibleHeight: 64,
          resizibleWidth: 311,
          resizibleLeft: 631,
          resizibleTop: 1546,
          type: 'scale'
        }
      },
      margins: [36, 36, 36, 36],
      zoomFactor: 0.6
    },
    portrait: {
      mapProps: {
        resizibleLeft: 50,
        resizibleTop: 50,
        resizibleHeight: 1400,
        resizibleWidth: 1400
      },
      elements: {
        legend: {
          resizibleHeight: 796,
          resizibleWidth: 1484,
          resizibleLeft: 50,
          resizibleTop: 1484,
          type: 'legend'
        },
        scale: {
          resizibleHeight: 64,
          resizibleWidth: 311,
          resizibleLeft: 629,
          resizibleTop: 1430,
          type: 'scale'
        }
      },
      margins: [36, 36, 36, 36],
      zoomFactor: 0.6
    }
  },
  A1: {
    landscape: {
      mapProps: {
        resizibleLeft: 50,
        resizibleTop: 50,
        resizibleHeight: 1400,
        resizibleWidth: 1400
      },
      elements: {
        legend: {
          resizibleHeight: 1516,
          resizibleWidth: 688,
          resizibleLeft: 1600,
          resizibleTop: 34,
          type: 'legend'
        },
        scale: {
          resizibleHeight: 64,
          resizibleWidth: 311,
          resizibleLeft: 631,
          resizibleTop: 1546,
          type: 'scale'
        }
      },
      margins: [36, 36, 36, 36],
      zoomFactor: 0.6
    },
    portrait: {
      mapProps: {
        resizibleLeft: 50,
        resizibleTop: 50,
        resizibleHeight: 1400,
        resizibleWidth: 1400
      },
      elements: {
        legend: {
          resizibleHeight: 796,
          resizibleWidth: 1484,
          resizibleLeft: 50,
          resizibleTop: 1484,
          type: 'legend'
        },
        scale: {
          resizibleHeight: 64,
          resizibleWidth: 311,
          resizibleLeft: 629,
          resizibleTop: 1430,
          type: 'scale'
        }
      },
      margins: [36, 36, 36, 36],
      zoomFactor: 0.6
    }
  },
  A0: {
    landscape: {
      mapProps: {
        resizibleLeft: 50,
        resizibleTop: 50,
        resizibleHeight: 1400,
        resizibleWidth: 1400
      },
      elements: {
        legend: {
          resizibleHeight: 1516,
          resizibleWidth: 688,
          resizibleLeft: 1600,
          resizibleTop: 34,
          type: 'legend'
        },
        scale: {
          resizibleHeight: 64,
          resizibleWidth: 311,
          resizibleLeft: 631,
          resizibleTop: 1546,
          type: 'scale'
        }
      },
      margins: [36, 36, 36, 36],
      zoomFactor: 0.6
    },
    portrait: {
      mapProps: {
        resizibleLeft: 50,
        resizibleTop: 50,
        resizibleHeight: 1400,
        resizibleWidth: 1400
      },
      elements: {
        legend: {
          resizibleHeight: 796,
          resizibleWidth: 1484,
          resizibleLeft: 50,
          resizibleTop: 1484,
          type: 'legend'
        },
        scale: {
          resizibleHeight: 64,
          resizibleWidth: 311,
          resizibleLeft: 629,
          resizibleTop: 1430,
          type: 'scale'
        }
      },
      margins: [36, 36, 36, 36],
      zoomFactor: 0.6
    }
  }
}
